import Vue from 'vue';
import { EventManager } from '../vue/EventManager.js';
import AOS from 'aos';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import TestComponent from '../vue/TestComponent.vue';
import SiteHeader from '../vue/SiteHeader.vue';
// import SingleCta from '../vue/SingleCta.vue';
// import QuickLinks from '../vue/QuickLinks.vue';
// import StandardHeader from '../vue/StandardHeader.vue';
import RichText from '../vue/RichText.vue';
// import VideoButton from '../vue/VideoButton.vue';
// import FeaturedCta from '../vue/FeaturedCta.vue';
import SiteFooter from '../vue/SiteFooter.vue';
// import AlertBanner from '../vue/AlertBanner.vue';
// import MobileMenu from '../vue/MobileMenu.vue';
import PrimaryButton from '../vue/PrimaryButton.vue';
// import SecondaryButton from '../vue/SecondaryButton.vue';
// import TertiaryButton from '../vue/TertiaryButton.vue';
// import AcknowledgementOfCountry from '../vue/AcknowledgementOfCountry.vue';
import SearchListing from '../vue/SearchListing.vue';
// import LoadingAnimation from '../vue/LoadingAnimation.vue';
import BreadCrumbs from '../vue/BreadCrumbs.vue';
// import NotFound from '../vue/NotFound.vue';
// import PageDivider from '../vue/PageDivider.vue';
// import HeroHeader from '../vue/HeroHeader.vue';
// import HeroHeaderSlider from '../vue/HeroHeaderSlider.vue';
import StandardHeader from '../vue/StandardHeader.vue';
import VideoImage from '../vue/VideoImage.vue';
// import FeaturedContent from '../vue/FeaturedContent.vue';
// import MultiColumn from '../vue/MultiColumn.vue';
import MediaAndText from '../vue/MediaAndText.vue';
// import ProofPoints from '../vue/ProofPoints.vue';
// import ImageGallery from '../vue/ImageGallery.vue';
// import SingleQuote from '../vue/SingleQuote.vue';
// import MixedContent from '../vue/MixedContent.vue';
// import ContentSlider from '../vue/ContentSlider.vue';
// import ImageSlider from '../vue/ImageSlider.vue';
// import TestimonialSlider from '../vue/TestimonialSlider.vue';
import AccordionItem from '../vue/AccordionItem.vue';
import AccordionWrapper from '../vue/AccordionWrapper.vue';
// import DownloadsLinks from '../vue/DownloadsLinks.vue';
// import FeaturedCtas from '../vue/FeaturedCtas.vue';
// import FeaturedPostListing from '../vue/FeaturedPostListing.vue';
// import FeaturedPeople from '../vue/FeaturedPeople.vue';
// import PostListing from '../vue/PostListing.vue';
// import MobilePageSelect from '../vue/MobilePageSelect.vue';
// import TwoThreeImages from '../vue/TwoThreeImages.vue';
// import ProjectListing from '../vue/ProjectListing.vue';
// import ProjectHeader from '../vue/ProjectHeader.vue';
// import StoreLocator from '../vue/StoreLocator.vue';
import GalleryModule from '../vue/GalleryModule.vue';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueLazyload);
const router = new VueRouter({ mode: 'history' });

export default {
  init() {
    // JavaScript to be fired on all pages
    let vueArea = document.querySelectorAll('.app, .loadvue');

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {
        mobile_menu: false,
        alert_bar_closed: false,
        alert_bar_id: false,
      },
      getters: {},
      mutations: {
        closeAlertBar(state, payload) {
          state.alert_bar_closed = payload;
        },
        alertBarID(state, payload) {
          state.alert_bar_id = payload;
        },
        toggleMobileMenu(state, payload) {
          state.mobile_menu = payload;
        },
      },
      actions: {},
      plugins: [createPersistedState()],
    });

    if (vueArea) {
      vueArea.forEach((element) => {
        new Vue({
          store: store,
          router,
          data: {
            topScrollThreshold: 100,
            isScrolled: false,
            isPageReady: false,
          },

          components: {
            TestComponent,
            SiteHeader,
            // QuickLinks,
            // StandardHeader,
            // VideoButton,
            // ImageGallery,
            // FeaturedCta,
            // FeaturedPostListing,
            // MixedContent,
            // SingleCta,
            SiteFooter,
            // AlertBanner,
            // MobileMenu,
            PrimaryButton,
            // SecondaryButton,
            // SingleQuote,
            // TertiaryButton,
            // AcknowledgementOfCountry,
            SearchListing,
            // LoadingAnimation,
            BreadCrumbs,
            // NotFound,
            // PageDivider,
            // HeroHeader,
            // HeroHeaderSlider,
            StandardHeader,
            RichText,
            // ProofPoints,
            VideoImage,
            // FeaturedContent,
            // MultiColumn,
            MediaAndText,
            // StoreLocator,
            // ContentSlider,
            // ImageSlider,
            // TestimonialSlider,
            AccordionItem,
            AccordionWrapper,
            // DownloadsLinks,
            // FeaturedCtas,
            // FeaturedPostListing,
            // FeaturedPeople,
            // PostListing,
            // MobilePageSelect,
            // TwoThreeImages,
            // ProjectListing,
            // ProjectHeader,
            GalleryModule,
          },

          methods: {
            onRefreshAos: function () {
              AOS.refresh();
            },
            didScroll() {
              this.isScrolled = window.scrollY > this.topScrollThreshold;
              this.updateTrigger();
            },

            updateTrigger() {
              var sideNav = document.querySelector(
                '.page-template-template-side_nav',
              );
              var hash = window.location.hash;
              let navAccordion = document.querySelectorAll(
                '.anchored_nav__inner',
              );

              if (hash && sideNav && navAccordion) {
                navAccordion.forEach((element) => {
                  var accordion_content = element.querySelectorAll('ul li');

                  if (accordion_content) {
                    accordion_content.forEach((element) => {
                      let theLink = element.querySelector('a');

                      if (theLink != null) {
                        if (
                          theLink.href.split('#')[1] === hash.replace('#', '')
                        ) {
                          element.classList.add('current');
                        } else {
                          element.classList.remove('current');
                        }
                      }
                    });
                  }
                });
              }
            },
          },

          created() {
            window.addEventListener('scroll', this.didScroll);
            // this.updateTrigger();
          },

          destroyed() {
            window.removeEventListener('scroll', this.didScroll);
          },

          mounted() {
            var self = this;
            setTimeout(function () {
              self.isPageReady = true;
              AOS.init();
            }, 500);

            self.$Lazyload.$on(
              'loaded',
              /* eslint-disable no-unused-vars */
              function (
                {
                  bindType,
                  el,
                  naturalHeight,
                  naturalWidth,
                  $parent,
                  src,
                  loading,
                  error,
                },
                formCache,
              ) {
                // Lazy loading images can cause AOS to get out of sync because the loaded image changes the height of the content
                // so refreshing it in order to re-calculate trigger points
                EventManager.$emit('should-refresh-aos');
              },
              /* eslint-enable no-unused-vars */
            );
          },
        }).$mount(element);

        /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

        for (var ii = 0; ii < matchingElements.length; ii++) {
          matchingElements[ii].innerHTML = hiddenMarkup[ii];
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js